<template>
	<v-row>
		<v-col cols="12">
			<v-card>
				<v-card-title>
					Certificados mTLS - Itaú
					<v-spacer />
					<v-btn
						v-if="permissao('boleto_certificado_visualizar') || permissao('boleto_certificado_renovar')"
						small
						outlined
						color="teal"
						class="mr-2"
						:loading="inspecionandoCadeia"
						@click="inspecionarCadeia"
					>Inspecionar cadeia</v-btn>
					<v-btn icon :loading="carregando" @click="listar">
						<v-icon>mdi-refresh</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider />
				<v-card-text>
					<v-skeleton-loader v-if="carregandoSkeleton" type="table-tbody" />
					<v-data-table
						v-else
						:headers="headers"
						:items="lista"
						item-key="idempresa"
						sort-by="idempresa"
						:sort-desc="false"
						:items-per-page="-1"
						hide-default-footer
						no-data-text="Nenhum certificado encontrado"
					>
						<template v-slot:item.flagsimulacao="{ item }">
							<v-chip
								small
								:color="item.flagsimulacao ? 'grey' : 'primary'"
								text-color="white"
								:class="{ 'chip-clicavel': permissao('boleto_flag_simulacao_atualizar') }"
								@click="permissao('boleto_flag_simulacao_atualizar') && confirmarFlagSimulacao(item)"
							>
								{{ item.flagsimulacao ? 'Simulação' : 'Produção' }}
								<v-icon
									v-if="permissao('boleto_flag_simulacao_atualizar')"
									right
									small
								>mdi-pencil</v-icon>
							</v-chip>
						</template>

						<template v-slot:item.ultimoboletogerado="{ item }">
							<v-chip v-if="!item.ultimoboletogerado" small outlined color="grey">
								<v-icon left small>mdi-file-remove-outline</v-icon>Nunca emitiu
							</v-chip>
							<span v-else>{{ formatarUltimoBoleto(item.ultimoboletogerado) }}</span>
						</template>

						<template v-slot:item.validoate="{ item }">
							<span v-if="item.erro" class="red--text">{{ item.erro }}</span>
							<span v-else>{{ formatarDataHora(item.validoate) }}</span>
						</template>

						<template v-slot:item.diasrestantes="{ item }">
							<v-chip
								v-if="!item.erro"
								small
								:color="corDiasRestantes(item.diasrestantes)"
								text-color="white"
							>{{ item.diasrestantes }} dias</v-chip>
							<span v-else>-</span>
						</template>

						<template v-slot:item.acao="{ item }">
							<v-btn
								v-if="permissao('boleto_certificado_visualizar') || permissao('boleto_certificado_renovar')"
								small
								outlined
								color="primary"
								class="mr-1"
								:loading="!!testando[item.idempresa]"
								:disabled="!!item.erro"
								@click="testarAutenticacao(item)"
							>Testar</v-btn>
							<v-tooltip
								bottom
								:disabled="item.flagsimulacao"
							>
								<template v-slot:activator="{ on, attrs }">
									<span v-bind="attrs" v-on="on">
										<v-btn
											v-if="permissao('boleto_certificado_visualizar') || permissao('boleto_certificado_renovar')"
											small
											outlined
											color="orange darken-2"
											class="mr-1"
											:loading="!!testandoEmissao[item.idempresa]"
											:disabled="!!item.erro || !item.flagsimulacao"
											@click="testarEmissao(item)"
										>Testar emissão</v-btn>
									</span>
								</template>
								<span>Só disponível em modo Simulação, pra não emitir um boleto real</span>
							</v-tooltip>
							<v-tooltip
								bottom
								:disabled="item.flagsimulacao"
							>
								<template v-slot:activator="{ on, attrs }">
									<span v-bind="attrs" v-on="on">
										<v-btn
											v-if="permissao('boleto_certificado_visualizar') || permissao('boleto_certificado_renovar')"
											small
											outlined
											color="deep-purple"
											class="mr-1"
											:loading="!!testandoEmissaoNovaUrl[item.idempresa]"
											:disabled="!!item.erro || !item.flagsimulacao"
											@click="testarEmissaoNovaUrl(item)"
										>Testar emissão (URL nova)</v-btn>
									</span>
								</template>
								<span>Só disponível em modo Simulação. Emite um boleto de teste na URL nova do Boleto com Pix</span>
							</v-tooltip>
							<v-btn
								v-if="permissao('boleto_certificado_visualizar') || permissao('boleto_certificado_renovar')"
								small
								outlined
								color="teal"
								class="mr-1"
								:loading="!!testandoCadeia[item.idempresa]"
								:disabled="!!item.erro"
								@click="testarCadeia(item)"
							>Testar cadeia</v-btn>
							<v-btn
								v-if="permissao('boleto_certificado_visualizar') || permissao('boleto_certificado_renovar')"
								small
								outlined
								color="indigo"
								class="mr-1"
								:loading="!!testandoWebhook[item.idempresa]"
								:disabled="!!item.erro"
								@click="testarWebhook(item)"
							>Testar webhook</v-btn>
							<v-btn
								v-if="permissao('boleto_certificado_renovar')"
								small
								color="primary"
								:loading="!!renovando[item.idempresa]"
								:disabled="!!item.erro"
								@click="confirmarRenovacao(item)"
							>Renovar</v-btn>
						</template>
					</v-data-table>
				</v-card-text>
			</v-card>
		</v-col>

		<v-col cols="12" v-if="permissao('boleto_certificado_visualizar') || permissao('boleto_certificado_renovar')">
			<TiPainelItau :filiais="lista" @testar="acaoPainel" />
		</v-col>

		<v-dialog v-model="dialogConfirma" width="450">
			<v-card class="pa-5">
				<v-card-title class="text-h4">
					<span class="mx-auto">Renovar certificado</span>
				</v-card-title>
				<div class="text-center py-3">
					<v-icon size="100" color="orange darken-2">mdi-certificate-outline</v-icon>
				</div>
				<v-card-text class="text-h6 text-center">
					Confirma a renovação do certificado da filial
					{{ filialSelecionada && filialSelecionada.idempresa }} junto ao Itaú? O certificado atual será substituído (uma cópia de segurança fica salva no servidor).
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn color="green darken-3" elevation="0" class="px-10" @click="renovar">Sim</v-btn>
					<v-btn color="red darken-3" elevation="0" class="px-10" @click="dialogConfirma = false">Não</v-btn>
					<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogConfirmaFlag" width="450">
			<v-card class="pa-5">
				<v-card-title class="text-h4">
					<span class="mx-auto">Alterar ambiente</span>
				</v-card-title>
				<div class="text-center py-3">
					<v-icon size="100" color="orange darken-2">mdi-swap-horizontal</v-icon>
				</div>
				<v-card-text class="text-h6 text-center">
					Confirma mudar a filial {{ filialFlagSelecionada && filialFlagSelecionada.idempresa }} de
					<strong>{{ filialFlagSelecionada && filialFlagSelecionada.flagsimulacao ? 'Simulação' : 'Produção' }}</strong>
					para
					<strong>{{ filialFlagSelecionada && !filialFlagSelecionada.flagsimulacao ? 'Simulação' : 'Produção' }}</strong>?
					<div
						v-if="filialFlagSelecionada && !filialFlagSelecionada.flagsimulacao"
						class="red--text text-body-2 mt-2"
					>Atenção: colocar em Simulação impede a emissão de boletos reais/válidos nessa filial.</div>
					<div v-else class="red--text text-body-2 mt-2">
						Atenção: colocar em Produção faz essa filial passar a emitir boletos reais e válidos.
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn
						color="green darken-3"
						elevation="0"
						class="px-10"
						@click="atualizarFlagSimulacao"
					>Sim</v-btn>
					<v-btn
						color="red darken-3"
						elevation="0"
						class="px-10"
						@click="dialogConfirmaFlag = false"
					>Não</v-btn>
					<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogCadeia" max-width="1100">
			<v-card>
				<v-card-title>
					Cadeia de certificados do Itaú
					<v-spacer />
					<v-btn icon @click="dialogCadeia = false"><v-icon>mdi-close</v-icon></v-btn>
				</v-card-title>
				<v-divider />
				<v-card-text class="pt-4">
					<div v-for="end in cadeia" :key="end.endereco" class="mb-6">
						<div class="d-flex align-center mb-2">
							<strong class="mr-3">{{ end.endereco }}</strong>
							<v-chip small :color="end.emuso ? 'primary' : 'grey'" text-color="white" class="mr-2">
								{{ end.emuso ? "Usado por nós" : "Não usado por nós" }}
							</v-chip>
							<v-chip small :color="end.confiavel ? 'green' : 'red'" text-color="white">
								{{ end.confiavel ? "Servidor confia" : "Servidor NÃO confia" }}
							</v-chip>
						</div>
						<div v-if="end.erro" class="red--text text-body-2 mb-2">{{ end.erro }}</div>
						<v-simple-table v-if="end.certificados && end.certificados.length" dense>
							<thead>
								<tr>
									<th>Tipo</th>
									<th>Certificado</th>
									<th>Emitido por</th>
									<th>Válido até</th>
									<th>Dias</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(c, i) in end.certificados" :key="i">
									<td>{{ c.tipo }}</td>
									<td>{{ c.assunto }}</td>
									<td>{{ c.emissor }}</td>
									<td>{{ formatarDataHora(c.validoate) }}</td>
									<td>
										<v-chip small :color="corDiasRestantes(c.diasrestantes)" text-color="white">{{ c.diasrestantes }}</v-chip>
									</td>
								</tr>
							</tbody>
						</v-simple-table>
					</div>
					<div class="text-caption grey--text">
						Mostra só o handshake TLS (sem credenciais). Os dias do certificado do servidor são renovados pelo Itaú; o que importa acompanhar é a mudança de quem emite (nova CA) e o "Servidor confia".
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogErro.status" persistent>
			<CardDialog :dialog="dialogErro" />
		</v-dialog>
	</v-row>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import CardDialog from "../Widgets/CardDialog";
import TiPainelItau from "./TiPainelItau";

export default {
	name: "TiCertificadosItau",
	components: { CardDialog, TiPainelItau },
	data: () => ({
		carregando: false,
		carregandoSkeleton: true,
		lista: [],
		headers: [
			{ text: "Filial", value: "idempresa" },
			{ text: "Ambiente", value: "flagsimulacao" },
			{ text: "Último boleto", value: "ultimoboletogerado" },
			{ text: "Válido até", value: "validoate" },
			{ text: "Dias restantes", value: "diasrestantes" },
			{ text: "Ação", value: "acao", sortable: false, align: "center" },
		],
		renovando: {},
		testando: {},
		testandoEmissao: {},
		testandoWebhook: {},
		testandoCadeia: {},
		testandoEmissaoNovaUrl: {},
		inspecionandoCadeia: false,
		dialogCadeia: false,
		cadeia: [],
		dialogConfirma: false,
		filialSelecionada: null,
		atualizandoFlag: {},
		dialogConfirmaFlag: false,
		filialFlagSelecionada: null,
		dialogErro: {
			status: false,
			title: "",
			msg: "",
			icon: "",
			iconColor: "",
		},
	}),
	computed: {
		...mapState(["backendUrl"]),
	},
	methods: {
		listar() {
			this.carregando = true;
			return axios
				.post(`${this.backendUrl}boleto/certificado/listar`)
				.then((res) => {
					this.lista = res.data.lista || [];
					this.carregando = false;
					this.carregandoSkeleton = false;
				})
				.catch((e) => {
					this.carregando = false;
					this.carregandoSkeleton = false;
					this.abrirDialogErro(
						"Erro",
						this.erroFormatar(e) || "Não foi possível carregar os certificados.",
						"red"
					);
				});
		},
		confirmarRenovacao(item) {
			this.filialSelecionada = item;
			this.dialogConfirma = true;
		},
		renovar() {
			const item = this.filialSelecionada;
			if (!item) return;
			this.dialogConfirma = false;
			this.$set(this.renovando, item.idempresa, true);
			return axios
				.post(`${this.backendUrl}boleto/certificado/renovar`, {
					idempresa: item.idempresa,
				})
				.then((res) => {
					const atualizado = res.data;
					const idx = this.lista.findIndex((l) => l.idempresa === item.idempresa);
					if (idx !== -1) {
						this.lista.splice(idx, 1, {
							...this.lista[idx],
							...atualizado,
							erro: "",
						});
					}
					this.$set(this.renovando, item.idempresa, false);
					this.abrirDialogErro(
						"Sucesso",
						`Certificado da filial ${item.idempresa} renovado com sucesso! Novo vencimento: ${this.formatarDataHora(atualizado.validoate)}`,
						"success"
					);
				})
				.catch((e) => {
					this.$set(this.renovando, item.idempresa, false);
					this.abrirDialogErro(
						"Erro na renovação",
						this.erroFormatar(e) || "Não foi possível renovar o certificado.",
						"red"
					);
				});
		},
		testarAutenticacao(item) {
			this.$set(this.testando, item.idempresa, true);
			return axios
				.post(`${this.backendUrl}boleto/certificado/testar`, {
					idempresa: item.idempresa,
				})
				.then(() => {
					this.$set(this.testando, item.idempresa, false);
					this.abrirDialogErro(
						"Autenticação OK",
						`A filial ${item.idempresa} conseguiu autenticar normalmente junto ao Itaú (certificado e credenciais válidos).`,
						"success"
					);
				})
				.catch((e) => {
					this.$set(this.testando, item.idempresa, false);
					this.abrirDialogErro(
						"Falha na autenticação",
						this.erroFormatar(e) ||
							`Não foi possível autenticar a filial ${item.idempresa} junto ao Itaú.`,
						"red"
					);
				});
		},
		testarEmissao(item) {
			this.$set(this.testandoEmissao, item.idempresa, true);
			return axios
				.post(`${this.backendUrl}boleto/certificado/testar-emissao`, {
					idempresa: item.idempresa,
				})
				.then((res) => {
					this.$set(this.testandoEmissao, item.idempresa, false);
					this.abrirDialogErro(
						"Emissão de teste OK",
						`${res.data.mensagem} (Nosso número: ${res.data.numeronossonumero})`,
						"success"
					);
				})
				.catch((e) => {
					this.$set(this.testandoEmissao, item.idempresa, false);
					this.abrirDialogErro(
						"Falha na emissão de teste",
						this.erroFormatar(e) ||
							`Não foi possível emitir um boleto de teste para a filial ${item.idempresa}.`,
						"red"
					);
				});
		},
		acaoPainel({ acao, item }) {
			const metodos = {
				autenticacao: "testarAutenticacao",
				cadeia: "testarCadeia",
				webhook: "testarWebhook",
				emissao: "testarEmissao",
				emissaoNova: "testarEmissaoNovaUrl",
			};
			if (metodos[acao]) {
				this[metodos[acao]](item);
			}
		},
		inspecionarCadeia() {
			this.inspecionandoCadeia = true;
			return axios
				.post(`${this.backendUrl}boleto/certificado/inspecionar-cadeia`)
				.then((res) => {
					this.cadeia = res.data.lista || [];
					this.inspecionandoCadeia = false;
					this.dialogCadeia = true;
				})
				.catch((e) => {
					this.inspecionandoCadeia = false;
					this.abrirDialogErro(
						"Falha ao inspecionar a cadeia",
						this.erroFormatar(e) || "Não foi possível inspecionar a cadeia de certificados.",
						"red"
					);
				});
		},
		testarEmissaoNovaUrl(item) {
			this.$set(this.testandoEmissaoNovaUrl, item.idempresa, true);
			return axios
				.post(`${this.backendUrl}boleto/certificado/testar-emissao-nova-url`, {
					idempresa: item.idempresa,
				})
				.then((res) => {
					this.$set(this.testandoEmissaoNovaUrl, item.idempresa, false);
					this.abrirDialogErro(
						"Emissão na URL nova OK",
						`${res.data.mensagem} (Nosso número: ${res.data.numeronossonumero})`,
						"success"
					);
				})
				.catch((e) => {
					this.$set(this.testandoEmissaoNovaUrl, item.idempresa, false);
					this.abrirDialogErro(
						"Falha na emissão pela URL nova",
						this.erroFormatar(e) ||
							`Não foi possível emitir um boleto de teste na URL nova para a filial ${item.idempresa}.`,
						"red"
					);
				});
		},
		testarCadeia(item) {
			this.$set(this.testandoCadeia, item.idempresa, true);
			return axios
				.post(`${this.backendUrl}boleto/certificado/testar-cadeia`, {
					idempresa: item.idempresa,
				})
				.then((res) => {
					this.$set(this.testandoCadeia, item.idempresa, false);
					const ok = res.data.statuscode >= 200 && res.data.statuscode < 300;
					this.abrirDialogErro(
						ok ? "Cadeia OK" : `Itaú retornou HTTP ${res.data.statuscode}`,
						ok
							? `A filial ${item.idempresa} confia na cadeia de certificados atual do Itaú. ${res.data.resposta || ""}`
							: `Filial ${item.idempresa}: ${res.data.resposta || "(sem corpo)"}`,
						ok ? "success" : "red"
					);
				})
				.catch((e) => {
					this.$set(this.testandoCadeia, item.idempresa, false);
					this.abrirDialogErro(
						"Falha ao validar a cadeia",
						this.erroFormatar(e) ||
							`Não foi possível validar a cadeia de certificados para a filial ${item.idempresa}.`,
						"red"
					);
				});
		},
		testarWebhook(item) {
			this.$set(this.testandoWebhook, item.idempresa, true);
			return axios
				.post(`${this.backendUrl}boleto/webhook/testar`, {
					idempresa: item.idempresa,
				})
				.then((res) => {
					this.$set(this.testandoWebhook, item.idempresa, false);
					const ok = res.data.statuscode >= 200 && res.data.statuscode < 300;
					this.abrirDialogErro(
						ok ? "Webhook OK" : `Itaú retornou HTTP ${res.data.statuscode}`,
						`Filial ${item.idempresa} — HTTP ${res.data.statuscode}: ${res.data.resposta || "(sem corpo)"}`,
						ok ? "success" : "red"
					);
				})
				.catch((e) => {
					this.$set(this.testandoWebhook, item.idempresa, false);
					this.abrirDialogErro(
						"Falha no teste do webhook",
						this.erroFormatar(e) ||
							`Não foi possível testar o webhook para a filial ${item.idempresa}.`,
						"red"
					);
				});
		},
		confirmarFlagSimulacao(item) {
			this.filialFlagSelecionada = item;
			this.dialogConfirmaFlag = true;
		},
		atualizarFlagSimulacao() {
			const item = this.filialFlagSelecionada;
			if (!item) return;
			this.dialogConfirmaFlag = false;
			const novoValor = !item.flagsimulacao;
			this.$set(this.atualizandoFlag, item.idempresa, true);
			return axios
				.post(`${this.backendUrl}boleto/certificado/flag-simulacao`, {
					idempresa: item.idempresa,
					flagsimulacao: novoValor,
				})
				.then(() => {
					const idx = this.lista.findIndex((l) => l.idempresa === item.idempresa);
					if (idx !== -1) {
						this.$set(this.lista[idx], "flagsimulacao", novoValor);
					}
					this.$set(this.atualizandoFlag, item.idempresa, false);
					this.abrirDialogErro(
						"Sucesso",
						`Filial ${item.idempresa} agora está em modo ${novoValor ? "Simulação" : "Produção"}.`,
						"success"
					);
				})
				.catch((e) => {
					this.$set(this.atualizandoFlag, item.idempresa, false);
					this.abrirDialogErro(
						"Erro",
						this.erroFormatar(e) || "Não foi possível atualizar o ambiente da filial.",
						"red"
					);
				});
		},
		formatarUltimoBoleto(iso) {
			if (!iso) return "Nunca emitiu";
			return new Date(iso).toLocaleString("pt-BR");
		},
		abrirDialogErro(title, msg, iconColor) {
			this.dialogErro.title = title;
			this.dialogErro.msg = msg;
			this.dialogErro.icon =
				iconColor === "success" ? "mdi-check-circle-outline" : "mdi-alert-circle-outline";
			this.dialogErro.iconColor = iconColor;
			this.dialogErro.status = true;
		},
		formatarDataHora(iso) {
			if (!iso) return "-";
			return new Date(iso).toLocaleString("pt-BR");
		},
		corDiasRestantes(dias) {
			if (dias === null || dias === undefined) return "grey";
			if (dias < 0) return "red darken-3";
			if (dias < 30) return "red";
			if (dias < 60) return "orange";
			return "green";
		},
	},
	created() {
		this.listar();
	},
};
</script>

<style scoped>
.chip-clicavel {
	cursor: pointer;
}
</style>
